import React from 'react';
import MyAlgoConnect from '@randlabs/myalgo-connect';
import node from './nodeapi.json';
import approval from './contract/Launchpad/approval';
import clear from './contract/Launchpad/clear'
import algosdk from 'algosdk';
import { LaunchpadPost } from '../API/ApiFunctions';

const myAlgoWallet = new MyAlgoConnect();
window.Buffer = require('buffer/').Buffer;

    const algodClient = new algosdk.Algodv2('', node['algodclient'], '');
    const indexClient = new algosdk.Indexer('', node['indexerclient'], '');

    const connectWallet = async () => {
        localStorage.setItem("walletName", "myAlgoWallet");
            try {    
                let settings = {
                    shouldSelectOneAccount: true,
                    openManager: true
                }
    
              const accounts = await myAlgoWallet.connect(settings);
              const addresses = accounts.map((account) => account.address);
    
              console.log("addresses : ", addresses);
              localStorage.setItem("walletAddress", addresses[0]);
              localStorage.setItem("UserType", "wallet");
            } catch (err) {
              console.error(err);
            }
          };

    const toastDiv = (txId) =>
    (
        <div>
            <p> Transaction is successful &nbsp;<a style={{color:'#133ac6'}} href={txId} target="_blank" rel="noreferrer"><br/><p style={{fontWeight: 'bold'}}>View in Algo Explorer <svg width="15" height="14" viewBox="0 0 15 14" fill="none" xmlns="http://www.w3.org/2000/svg">
     <path d="M11.7176 3.97604L1.69366 14L0.046875 12.3532L10.0697 2.32926H1.23596V0H14.0469V12.8109H11.7176V3.97604Z" fill="#133ac6"/>
     </svg></p></a></p>  
        </div>
    );

    const waitForConfirmation = async function (client, txId) {
        let status = (await client.status().do());
        let lastRound = status["last-round"];
          while (true) {
            const pendingInfo = await client.pendingTransactionInformation(txId).do();
            if (pendingInfo["confirmed-round"] !== null && pendingInfo["confirmed-round"] > 0) {
              //Got the completed Transaction
              console.log("Transaction " + txId + " confirmed in round " + pendingInfo["confirmed-round"]);
            //   toast.success(`Transaction Successful with ${txId}`);
            let id = "https://testnet.algoexplorer.io/tx/" + txId;
            // console.log(toastDiv(id));
            // await sleep(5000);
            // reload();               
            break;
            }
            lastRound++;
            await client.statusAfterBlock(lastRound).do();
          }
        };  

        async function compileProgram(algodClient, programSource) {
            let encoder = new TextEncoder();
            let programBytes = encoder.encode(programSource);
            let compileResponse = await algodClient.compile(programBytes).do();
            let compiledBytes = new Uint8Array(Buffer.from(compileResponse.result, "base64"));
            return compiledBytes;
          }

    export const AlgorandLaunchpad = async () => {
        if (!localStorage.getItem("walletAddress") || localStorage.getItem("walletAddress") === "")
        {
            await connectWallet();
            await AlgorandLaunchpad();
        }
        else{
        // const algodClient = new algosdk.Algodv2('', 'https://api.testnet.algoexplorer.io', '');
        const accountInfo = await indexClient.lookupAccountByID(localStorage.getItem("walletAddress")).do();
        if((parseInt(accountInfo['account']['amount'])) < 423000)
        {
            console.log(`Your balance is ${(parseFloat(accountInfo['account']['amount'])/1000000)} Algos but trying to spend ${parseFloat(423000)/1000000} Algos`);
        }
        else{
            await createAsset();
    }
        }
    }

    const createAsset = async () => {
        try{
        let params = await algodClient.getTransactionParams().do();
        //comment out the next two lines to use suggested fee
        params.fee = 1000;
        params.flatFee = true;
        console.log(params);
        // Asset creation specific parameters
        // The following parameters are asset specific
        // Throughout the example these will be re-used. 
        // We will also change the manager later in the example
        let addr = localStorage.getItem("walletAddress");
        console.log(addr);
        // total number of this asset available for circulation   
        let totalIssuance = 18446744073709551615n;
        let decimals = 6;
        // Optional string pointing to a URL relating to the asset
        // let assetURL = assetUrlState;
        let assetName = "RewardAsset";
        let unitName = "RA";
        // The following parameters are the only ones
        // that can be changed, and they have to be changed
        // by the current manager
        // Specified address can change reserve, freeze, clawback, and manager
        let manager = localStorage.getItem("walletAddress");
        // Specified address is considered the asset reserve
        // (it has no special privileges, this is only informational)
        let reserve = localStorage.getItem("walletAddress");
        // Specified address can freeze or unfreeze user asset holdings 
        let freeze = localStorage.getItem("walletAddress");
        // Specified address can revoke user asset holdings and send 
        // them to other addresses    
        let clawback = localStorage.getItem("walletAddress");
    
        // signing and sending "txn" allows "addr" to create an asset
        let txn = algosdk.makeAssetCreateTxnWithSuggestedParamsFromObject(
          {
            from: addr,
            assetName: assetName,
            unitName: unitName,
            total: totalIssuance,
            decimals: parseInt(decimals),
            manager: manager,
            reserve: reserve,
            freeze: freeze,
            clawback: clawback,
            suggestedParams: params
          }
        );
    
        const signedTxn = await myAlgoWallet.signTransaction(txn.toByte());
        
        const response = await algodClient.sendRawTransaction(signedTxn.blob).do();
        await waitForConfirmation(algodClient, response.txId);
        let ptx = await algodClient.pendingTransactionInformation(response.txId).do();
        await createApp(ptx["asset-index"]);
        }  
        catch (err) {
          console.log(err.toString());
          console.error(err);
      }
    }

    const createApp = async (assetID) => {
    // declare onComplete as NoOp
    let onComplete = algosdk.OnApplicationComplete.NoOpOC;

	  // get node suggested parameters
    let params = await algodClient.getTransactionParams().do();

    let approvalProgram = await compileProgram(algodClient, approval);
    let clearProgram = await compileProgram(algodClient, clear);
    let decAddr = algosdk.decodeAddress(localStorage.getItem("walletAddress"));

    let startEpoch = parseInt((Date.now() / 1000).toFixed(0));
    console.log("startEpoch", startEpoch);
    let endEpoch = startEpoch + 7889229;

    let appCreateArgs = [];
    appCreateArgs.push(algosdk.encodeUint64(startEpoch)); //start date
    appCreateArgs.push(algosdk.encodeUint64(endEpoch)); //end date
    appCreateArgs.push(algosdk.encodeUint64(1000000000000)); //goal amount
    appCreateArgs.push(decAddr.publicKey); //receiver
    appCreateArgs.push(algosdk.encodeUint64(endEpoch)); //close date
    appCreateArgs.push(algosdk.encodeUint64(parseInt(assetID))); //assetID
  try {

    const txn = algosdk.makeApplicationCreateTxnFromObject({
        suggestedParams: params,
        from: localStorage.getItem("walletAddress"),
        appArgs: appCreateArgs,
        onComplete: onComplete,
        approvalProgram: approvalProgram,
        clearProgram: clearProgram,
        numLocalInts: 2,
        numLocalByteSlices: 0,
        numGlobalInts: 6,
        numGlobalByteSlices: 2,
    });

    const signedTxn = await myAlgoWallet.signTransaction(txn.toByte());
    const response = await algodClient.sendRawTransaction(signedTxn.blob).do();
    //toast.success(`Transaction Success ${response.txId}`);
    await waitForConfirmation(algodClient, response.txId);
    // display results
    let transactionResponse = await algodClient.pendingTransactionInformation(response.txId).do();
    console.log(transactionResponse);
    let appId = transactionResponse['application-index'];
    console.log("Created new app-id: ", appId);
      await appAddressSetup(appId, assetID, startEpoch, endEpoch);
    //   toast.success(`Transaction Successfully completed with ${response.txId}`);
    //   //toast.info(`Now you have obtained Element amount = ( ${(parseFloat(Pop_amount) * 2).toFixed(2)} ELEM )`);
        } catch (err) {
          console.log(`Transaction Failed due to ${err}`);
          console.error(err);
        }
    }

    const appAddressSetup = async (appId, assetID, startEpoch, endEpoch) =>
    {
        let appAddress = algosdk.getApplicationAddress(parseInt(appId));

        console.log("appAddress =", appAddress);
        try {
            //   const accounts = await myAlgoWallet.connect();
              // const addresses = accounts.map(account => account.address);
              let sender = localStorage.getItem("walletAddress");
              const params = await algodClient.getTransactionParams().do();
        
              let transaction1 = algosdk.makePaymentTxnWithSuggestedParamsFromObject({
                from: sender, 
                to: appAddress, 
                amount: 201000,  
                suggestedParams: params
               });

              let appArgs1 = [];
              appArgs1.push(new Uint8Array(Buffer.from("appAddressOptin")));
    
              let foreinAssetId = [];
              foreinAssetId.push(parseInt(parseInt(assetID)));
    
            //   let recv_escrow = escrow;
              // create unsigned transaction
              let transaction2 = algosdk.makeApplicationNoOpTxnFromObject({
                from:sender, 
                suggestedParams: params, 
                appIndex: parseInt(appId), 
                appArgs: appArgs1,
                foreignAssets: foreinAssetId
              })                    
              
              let transaction3 = algosdk.makeAssetTransferTxnWithSuggestedParamsFromObject({
                from: sender, 
                to: appAddress, 
                amount: 2000000000000,  
                assetIndex: parseInt(assetID),
                suggestedParams: params
               });
              
              const groupID = algosdk.computeGroupID([ transaction1, transaction2, transaction3]);
              const txs = [ transaction1, transaction2, transaction3];
              txs[0].group = groupID;
              txs[1].group = groupID;
              txs[2].group = groupID;
    
              const signedTx1 = await myAlgoWallet.signTransaction([txs[0].toByte(), txs[1].toByte(), txs[2].toByte()]);

          const response = await algodClient.sendRawTransaction([signedTx1[0].blob, signedTx1[1].blob, signedTx1[2].blob]).do();

          await waitForConfirmation(algodClient, response.txId);
          await LaunchpadPost(assetID, appId, startEpoch, endEpoch, appAddress);
            } catch (err) {
              console.log(`Transaction Failed due to ${err}`);
              console.error(err);
            }
    }